var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvancesDisbursement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32.2 29.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24874",
    "data-name": "Path 24874",
    d: "M14.3,2.767A4.136,4.136,0,0,1,20,3.612l.465-.327a4.119,4.119,0,0,1,6.179,1.785l1.519,3.743a5.5,5.5,0,0,1,3.106,4.933v2.719a4.021,4.021,0,0,1,0,7.766v1.252a5.542,5.542,0,0,1-5.581,5.5H7.831a5.542,5.542,0,0,1-5.581-5.5V13.745A5.52,5.52,0,0,1,6.506,8.4Zm-.87,5.476H10.5l5.12-3.7a1.88,1.88,0,0,1,2.569.351ZM24.575,5.887a1.873,1.873,0,0,0-2.809-.811l-4.5,3.167h8.263Zm2.6,18.495h1.86v1.1a3.325,3.325,0,0,1-3.349,3.3H7.831a3.325,3.325,0,0,1-3.349-3.3V13.745a3.325,3.325,0,0,1,3.349-3.3h17.86a3.325,3.325,0,0,1,3.349,3.3v2.567H27.18a4.035,4.035,0,1,0,0,8.069Zm-1.86-4.035a1.847,1.847,0,0,1,1.86-1.834h2.977a1.834,1.834,0,1,1,0,3.668H27.18A1.847,1.847,0,0,1,25.32,20.347ZM13,24.793a1.128,1.128,0,0,0,1.579,0l4.465-4.4a1.089,1.089,0,0,0,0-1.556,1.128,1.128,0,0,0-1.579,0L14.9,21.358V15.212a1.116,1.116,0,0,0-2.233,0v6.147l-2.56-2.523a1.128,1.128,0,0,0-1.579,0,1.089,1.089,0,0,0,0,1.556Z",
    transform: "translate(-2.15 -1.864)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancesDisbursement);
export default __webpack_public_path__ + "static/media/AdvancesDisbursement.d58acd88131722c11bf80ba6546c403b.svg";
export { ForwardRef as ReactComponent };